import { AccountMenu } from "@/components/nav/account-menu";
import { ThemeToggle } from "@/components/nav/theme-toggle";
import { cn } from "@/lib/cn";

export function SidebarUserFooter({ className }: { className?: string }) {
  return (
    <div className={cn("mt-auto border-t border-rs-border p-2", className)}>
      <div className="flex items-center gap-1">
        <AccountMenu
          className="min-w-0 flex-1 justify-start"
          align="start"
          side="top"
        />
        <ThemeToggle className="shrink-0" />
      </div>
    </div>
  );
}
